import * as z from 'zod';

import client from '@/services/client';
import { customerCasesClientPagePopulate } from '@/services/strapiPopulate';
import { formatZodError } from '@/utils/error';
import { mergeCustomerCaseClientPages } from '@/utils/customerCases/mergeCustomerCaseClientPages';

export async function fetchStrapiContentWithBlocks<T>(
  path: string,
  schema: z.ZodType<T>,
  populate: Record<string, unknown>,
  contentLabel: string,
): Promise<T> {
  const [response, enrichmentResponse] = await Promise.all([
    client.get(path, { params: { populate } }),
    client.get(path, { params: { populate: { blocks: customerCasesClientPagePopulate } } }),
  ]);

  const mergedData = mergeCustomerCaseClientPages(response.data?.data, enrichmentResponse.data?.data);

  try {
    return await schema.parseAsync(mergedData);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(`API response do not match ${contentLabel} structure:\n${formatZodError(error, mergedData)}`);
    }
    throw error;
  }
}
